import {
  ApiListResponse,
  PromotionDTO,
  PromotionPostDTO,
} from "@gymflow/types";
import { AxiosInstance } from "axios";

import { createSortParam } from "../createSortParam";
import { trimFields } from "./features/trimFiels";

export type PromotionApiType = ReturnType<typeof promotionApi>;

const promotionApi = (axiosInstance: AxiosInstance, clubId: number) => {
  const clubPrefix = `club/${clubId}/`;
  const fieldsToTrim = ["name", "code"];

  return {
    find({
      page = 0,
      limit = 10,
      extraParams = {},
      sort,
    }: {
      readonly page?: number;
      readonly limit?: number;
      readonly extraParams?: {
        readonly active?: boolean;
        readonly id?: number[];
        readonly code?: string;
        readonly [k: string]: any;
      };
      readonly [k: string]: any;
    }) {
      const config = {
        params: {
          page,
          size: limit,
          ...extraParams,
        },
      } as any;
      if (sort) {
        config.params.sort = createSortParam(sort);
      }
      return axiosInstance.get<ApiListResponse<PromotionDTO>>(
        `${clubPrefix}promotion`,
        config,
      );
    },
    findById(id: number) {
      return axiosInstance.get<PromotionDTO>(`${clubPrefix}promotion/${id}`);
    },
    create(newResource: PromotionPostDTO) {
      return axiosInstance.post<PromotionDTO>(
        `${clubPrefix}promotion`,
        trimFields(newResource, fieldsToTrim),
      );
    },
    update(id: number, patchedFields: Partial<PromotionPostDTO>) {
      return axiosInstance.patch<PromotionDTO>(
        `${clubPrefix}promotion/${id}`,
        trimFields(patchedFields, fieldsToTrim),
      );
    },
  };
};

export default promotionApi;
